import * as core from '../../../../../../../core'
import * as summit from '../summit'

export const RESOURCE = {
  payload: {
    alias: 'outcomes-tree-editor',
    appAlias: summit.RESOURCE.payload.alias,
    description:
      "Manage and monitor your organization's strategic goals through tree editing",
    display: {
      isMain: false,
      position: 3,
    },
    name: 'Outcomes (Tree editor)',
    page: { alias: 'summit:outcomes-tree-editor' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
